import fetcher from 'features/shared/utils/fetcher'

async function postRegisterResponsible(value:object) {
  
  return await fetcher.post('/patient/responsible/store',value)
}

export default postRegisterResponsible
